<template>
  <ValidationObserver ref="observer" slim v-slot="{ pristine }">
    <v-row>
      <v-col cols="12">
        <ValidationProvider
          vid="Password"
          :rules="passwordRules"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="password"
            :label="`Password${required ? '*' : ' (optional)'}`"
            type="password"
            outlined
            :error-messages="getPasswordErrors(pristine, errors)"
            autocomplete="new-password"
            hide-details
            :disabled="disabled"
          ></v-text-field>
          <v-list dense class="m-0 p-0">
            <v-list-item
              dense
              class="text-caption font-weight-bold"
              :class="{
                'success--text text--darken-2': passwordHasLength,
                'red--text': !pristine && !passwordHasLength,
              }"
            >
              <v-icon v-if="passwordHasLength" x-small class="mr-1"
                >$check</v-icon
              >
              <v-icon v-else-if="required" x-small class="mr-1">$close</v-icon>
              Must be at least 6 characters long
            </v-list-item>
            <v-list-item
              dense
              class="text-caption font-weight-bold"
              :class="{
                'success--text text--darken-2': passwordHasLower,
                'red--text': !pristine && !passwordHasLower,
              }"
            >
              <v-icon v-if="passwordHasLower" x-small class="mr-1"
                >$check</v-icon
              >
              <v-icon v-else-if="required" x-small class="mr-1">$close</v-icon>
              Must contain a lowercase letter.
            </v-list-item>
            <v-list-item
              dense
              class="text-caption font-weight-bold"
              :class="{
                'success--text text--darken-2': passwordHasUpper,
                'red--text': !pristine && !passwordHasUpper,
              }"
            >
              <v-icon v-if="passwordHasUpper" x-small class="mr-1"
                >$check</v-icon
              >
              <v-icon v-else-if="required" x-small class="mr-1">$close</v-icon>
              Must contain a uppercase letter.
            </v-list-item>
            <v-list-item
              dense
              class="text-caption font-weight-bold"
              :class="{
                ' success--text text--darken-2': passwordHasNumber,
                'red--text': !pristine && !passwordHasNumber,
              }"
            >
              <v-icon v-if="passwordHasNumber" x-small class="mr-1"
                >$check</v-icon
              >
              <v-icon v-else-if="required" x-small class="mr-1">$close</v-icon>
              Must contain a number.
            </v-list-item>
          </v-list>
        </ValidationProvider>
      </v-col>
      <v-col cols="12">
        <ValidationProvider :rules="confirmRules" v-slot="{ errors }">
          <v-text-field
            v-model="confirm"
            name="password confirmation"
            :label="`Confirm Password${required ? '*' : ' (optional)'}`"
            type="password"
            outlined
            :error-messages="errors"
            autocomplete="new-password"
            :disabled="disabled"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
  </ValidationObserver>
</template>

<script>
export default {
  name: "Password",
  props: {
    value: String,
    required: Boolean,
    disabled: Boolean,
  },
  data: () => ({
    password: "",
    confirm: "",
  }),
  computed: {
    passwordHasLength() {
      return this.password.length >= 6;
    },
    passwordHasUpper() {
      return /[A-Z]/.test(this.password);
    },
    passwordHasLower() {
      return /[a-z]/.test(this.password);
    },
    passwordHasNumber() {
      return /[0-9]/.test(this.password);
    },
    valid() {
      return (
        this.passwordHasLength &&
        this.passwordHasUpper &&
        this.passwordHasNumber &&
        this.passwordHasNumber
      );
    },
    passwordRules() {
      let rules = [];

      if (this.required) rules.push("required");
      rules.push("max:255");

      return rules.join("|");
    },
    confirmRules() {
      let rules = [];

      if (this.required) rules.push("required");
      rules.push("confirmed:Password");

      return rules.join("|");
    },
  },
  watch: {
    value(val) {
      if (val != this.password) {
        this.password = val + "";
      }
    },
    password(val) {
      if (val != this.value) this.$emit("input", val);
    },
    getPasswordErrors(pristine, fieldErrors) {
      let errors = [];
      if (!pristine) {
        if (!this.valid) errors.push("invalid password");
        errors = errors.concat(fieldErrors);
      }

      return errors;
    },
  },
  methods: {
    getPasswordErrors(pristine, fieldErrors) {
      let errors = [];
      if (!pristine) {
        if (!this.valid) errors.push("invalid password");
        errors = errors.concat(fieldErrors);
      }

      return errors;
    },
  },
  mounted() {
    if (this.value) this.password = this.value + "";
  },
};
</script>

<style scoped>
.v-list-item {
  min-height: 0 !important;
}
</style>
